export default "__VITE_ASSET__Z5LUhO2e__"